import { Component, ViewEncapsulation } from '@angular/core';

import { TranslationService } from '@lib/translation';

interface LanguageOption {
  code: string;
  nativeName: string;
}

@Component({
  selector: 'fr-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LanguageSelectorComponent {
  public readonly languages: LanguageOption[] = this._getSupportedLanguages();
  public selectedLanguage: string;
  public selectedLanguageName: string;

  constructor(private readonly _translationService: TranslationService) {
    this.selectedLanguage = this._getInitialLanguage();
  }

  public onLanguageChange(languageCode: string): void {
    this._translationService.setActiveLang(languageCode);
    localStorage.setItem('fusus_registry_language', languageCode);
    this.selectedLanguage = languageCode;
  }

  public getSelectedLanguageName(): string {
    const selected = this.languages.find((lang) => lang.code === this.selectedLanguage);
    return selected ? selected.nativeName : 'English (US)';
  }

  private _getInitialLanguage(): string {
    const fallbackLanguage = 'en-US';
    this._translationService.setActiveLang(fallbackLanguage);
    return fallbackLanguage;
  }

  private _getSupportedLanguages(): LanguageOption[] {
    return [{ code: 'en-US', nativeName: 'English (US)' }];
  }
}

